<template>
	<div>
		<van-tabbar v-model="active" :border="false" active-color="#5f6b80" inactive-color="#848689" :placeholder="true" >
			<van-tabbar-item @click="goIndex">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item @click="goActivity">
				<span>活动</span>
				<template #icon="props">
					<img :src="props.active ? activity.active : activity.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item @click="showPopup">
				<template>
					<img src="../assets/tab_create_nor.png" class="add"/>
				</template>
			</van-tabbar-item>
			<van-tabbar-item @click="goCircle">
				<span>圈子</span>
				<template #icon="props">
					<img :src="props.active ? circle.active : circle.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item @click="goMe">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? me.active : me.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
		
		<van-popup v-model="show" position="bottom" :style="{ height: '30%' }">内容</van-popup>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Tabbar,
		TabbarItem
	} from 'vant';
	import {getCookie} from "@/utils/cookie/public"
	Vue.use(Tabbar);
	Vue.use(TabbarItem);
	export default {
		data() {
			return {
				// token:'',
				show: false,
				active: 0,
				index: {
					active: require('../assets/tab_ls_sel.png'),
					inactive: require('../assets/tab_ls_nor.png'),
				},
				activity: {
					active: require('../assets/tab_hd_sel.png'),
					inactive: require('../assets/tab_hd_nor.png'),
				},
				circle: {
					active: require('../assets/tab_qz_sel.png'),
					inactive: require('../assets/tab_qz_nor.png'),
				},
				me: {
					active: require('../assets/tab_i_sel.png'),
					inactive: require('../assets/tab_i_nor.png'),
				},
			};
		},
		mounted(){
			this.token = getCookie('token');
		},
		methods: {
			showPopup() {
				// var that=this;
				// if (that.token==''){
				// 	var refurl = encodeURIComponent(window.location.href);
				// 	window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=user&a=login&refurl=${refurl}`
				// 	return false;
				
				// } else {
				// 	// this.show = true;
				// 	window.location.href = 'http://android.myapp.com/myapp/detail.htm?apkName=lushu.xoosh.cn.xoosh&ADTAG=mobile'
				// }
				window.location.href = 'http://android.myapp.com/myapp/detail.htm?apkName=lushu.xoosh.cn.xoosh&ADTAG=mobile'
			},
			goIndex(){
				if (this.$route.path != '/index/index/') {
					this.$router.push({path:"/index/index/"});
				}
			},
			goActivity(){
				window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=activity&a=getlist`
				// if (this.$route.path != '/activity/list/') {
				// 	this.$router.push({path:"/activity/list/"});
				// }
			},
			goCircle(){
				window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=timeline&a=getList`
			},
			goMe(){
				window.location.href = `${process.env.VUE_APP_MAIN_DOMAIN}?m=myself&a=index`
			},
		}
	};
</script>

<style scoped>
	img{
		width: 30px;
		height: 30px;
	}
	.add{
		width: 65px;
		height: 65px;
		margin-bottom: 20px;
	}
</style>
